import { LANGUAGE_CODES, ROUTES } from "../routes";
import i18n from "./i18n";

const stripLangPrefix = (path: string) => path.replace(/^\/(en|tr|pl)/, "");
const findBestRouteMatch = (pathWithoutLang: string) => {
  const cleanedPath = pathWithoutLang.replace(/^\/|\/$/g, "");
  const parts = cleanedPath.split("/");
  const parentMatch = Object.entries(ROUTES).find(([key, value]) =>
    Object.values(value).some(
      (val) =>
        val.replace(/^\/(en|tr|pl)/, "").replace(/^\/|\/$/g, "") === parts[0]
    )
  );
  if (!parentMatch) return null;
  const [parentKey] = parentMatch;
  const childSlug = parts[1];
  if (childSlug) {
    const childMatch = Object.entries(ROUTES).find(([key, value]) =>
      Object.values(value).some((val) => val === childSlug)
    );
    if (childMatch) {
      const [childKey] = childMatch;
      return { parentKey, childKey };
    }
    return { parentKey };
  }
  return { parentKey };
};

export const changeLanguage = (language: LANGUAGE_CODES) => {
  const currentPath = window.location.pathname;
  const pathWithoutLang = stripLangPrefix(currentPath);
  const match = findBestRouteMatch(pathWithoutLang);
  const langPrefix = language === LANGUAGE_CODES.EN ? "/en" : language === LANGUAGE_CODES.PL ? "/pl" : "/tr";
  let newPath = `${langPrefix}`;
  if (match) {
    const parentPath = ROUTES[match.parentKey][language].replace(
      /^\/(pl|tr|en)/,
      ""
    );
    if (match.childKey) {
      const childPath = ROUTES[match.childKey][language];
      newPath = `${langPrefix}/${parentPath}/${childPath}`;
    } else {
      newPath = `${langPrefix}${parentPath === "" ? "" : "/"}${parentPath}`;
    }
  }
  localStorage.setItem("language", language);
  i18n.changeLanguage(language).then(() => {
    window.location.pathname = newPath;
  });
};

export const currentLanguage: LANGUAGE_CODES = (() => {
  const storedLang = localStorage.getItem("language");
  if (storedLang === LANGUAGE_CODES.EN) return LANGUAGE_CODES.EN;
  if (storedLang === LANGUAGE_CODES.TR) return LANGUAGE_CODES.TR;
  if (storedLang === LANGUAGE_CODES.PL) return LANGUAGE_CODES.PL;
  if (window.location.pathname.startsWith("/en")) return LANGUAGE_CODES.EN;
  if (window.location.pathname.startsWith("/pl")) return LANGUAGE_CODES.PL;
  if (window.location.pathname.startsWith("/tr")) return LANGUAGE_CODES.TR;
  return LANGUAGE_CODES.PL;
})();
